module.exports = __webpack_public_path__ + "img/Dantam Hair 50.749347e7.jpg";